











































import {
  InjectionKey,
  PropType,
  computed,
  defineComponent,
  inject,
  provide,
  ref
} from '@vue/composition-api';
import { MaybeRef, useVModel } from '@vueuse/core';

import {
  ISystemError,
  IWorkflowFormFieldNode,
  IWorkflowFormSectionField,
  IWorkflowFormField
} from '@/models';
import { ALForm } from '@/common/component.types';
import {
  PropertyTabs,
  WorkflowFormBuilderForm
} from '../WorkflowFormBuilderPropertiesDrawer.vue';

import { VForm } from 'vuetify/lib/components';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import WorkflowFormBuilderComputationBuilder from '../computation/WorkflowFormBuilderComputationBuilder';
import { extractTextFromHtml } from '@/utils/helpers';

export interface WorkflowFormFieldProvide {
  revisionId: MaybeRef<number>;
  formFieldId?: MaybeRef<number>;
}

export const SelectedWorkflowFormFieldKey: InjectionKey<WorkflowFormFieldProvide> = Symbol.for(
  'workflow:form-field'
);

export default defineComponent({
  name: 'WorkflowFormBuilderCalculationTab',

  components: {
    ErrorAlert,
    WorkflowFormBuilderComputationBuilder
  },

  props: {
    value: {
      type: Object as PropType<IWorkflowFormSectionField>,
      required: true
    },
    selectedFieldIndex: Number,
    revisionId: Number
  },

  setup(props, { emit }) {
    const internalValue = useVModel(props, 'value');

    provide(SelectedWorkflowFormFieldKey, {
      revisionId: props.revisionId,
      formFieldId: computed(
        () => (internalValue.value.field_template as IWorkflowFormField).id
      ).value
    });

    const isFormDisabled = inject(WorkflowFormBuilderForm, true);

    const error = ref<ISystemError | null>(null);

    function clearError() {
      error.value = null;
    }

    function goToGeneralTabWindow() {
      const valid = validateForm();

      if (valid) {
        emit('goToTabWindow', PropertyTabs.General);
      }
    }

    const fieldNodes = computed({
      get() {
        return (internalValue.value.field_template as IWorkflowFormField).nodes;
      },
      set(nodes: IWorkflowFormFieldNode[]) {
        (internalValue.value
          .field_template as IWorkflowFormField).nodes = nodes;
      }
    });

    const formRef = ref<InstanceType<typeof VForm> & ALForm>();

    function validateForm(): boolean {
      let valid = false;
      if (formRef.value) {
        valid = formRef.value.validate();
      }
      return valid;
    }

    const isComputationFormValid = ref(false);

    const label = computed(() => {
      return (internalValue.value.field_template as IWorkflowFormField).label;
    });

    return {
      isFormDisabled,

      formRef,
      isComputationFormValid,

      error,
      clearError,

      fieldNodes,
      internalValue,
      goToGeneralTabWindow,
      validateForm,
      extractTextFromHtml,
      label
    };
  }
});
